// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"85":"41cfb689","195":"49f6f80d","630":"9de513d4","843":"c01a3dbc"}[chunkId] + ".chunk.js";
};